import { PhoneNumberUtil } from 'google-libphonenumber';
import { z } from 'zod';

const phoneNumberUtil = PhoneNumberUtil.getInstance();

export const generalInformationSchema = z.object({
  name: z.string({ required_error: 'First name is required' }).min(1),
  lastName: z
    .string({ required_error: 'Last name is required' })
    .refine(value => /^[A-Za-z]+$/i.test(value)),
  email: z.string().email().min(1),
  phone: z
    .string()
    .nullable()
    .refine(value => {
      if (!value) return true;

      try {
        const parsedNumber = phoneNumberUtil.parse(value);
        const isValidNumber = !!phoneNumberUtil.isValidNumber(parsedNumber);
        return isValidNumber;
      } catch {
        return false;
      }
    }, 'Invalid phone number'),
});

export const securitySchema = z
  .object({
    password: z
      .string()
      .refine(
        value =>
          /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*]).{8,}$/.test(value),
        'Minimum eight characters, at least one number and one special character'
      ),
    newPassword: z
      .string()
      .refine(
        value =>
          /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*]).{8,}$/.test(value),
        'Minimum eight characters, at least one number and one special character'
      ),
    confirmNewPassword: z.string().min(8),
  })
  .refine(data => data.password !== data.newPassword, {
    message: 'New password must be different from current password',
    path: ['newPassword'],
  })
  .refine(data => data.newPassword === data.confirmNewPassword, {
    message: "Passwords don't match",
    path: ['confirmNewPassword'],
  });
